import { get } from "../index";

// EVERY REVISION OF A FILED DOCUMENT, each with a DOWNLOAD URL.
//
// Owner, 2026-09-30, on the superseded-revisions work: "as long as you keep
// access for direct download of old revisions, yes."
//
// The route already existed and already authorises this - it returns a `url`
// per version carrying a short-lived signed token, served by
// GET /doc-control/:id/versions/:rev/file. So prior revisions are fetched
// through the path that already checks access rather than through a second one
// written beside it, and no raw storage link is ever handed to the browser.
//
// THE TOKEN IS SHORT-LIVED (ten minutes), which is why this is called when the
// revision list is OPENED rather than cached with the table: a url fetched with
// the page and clicked an hour later would 401, and "this link has expired -
// open the version list again" is a worse experience than one extra request.
export const getDocVersions = (id) => get(`/doc-control/${id}/versions`);
